import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import classnames from "classnames";

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Settings</h4>
      </div>
      <Card>
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
              >
                Store Settings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
              >
                Integrations
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggle("3")}
              >
                Coverage Zones
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggle("4")}
              >
                Other Settings
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            {/* Tab 1: Store Settings */}
            <TabPane tabId="1">
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="storeLogo">Store Logo</Label>
                    <Input type="file" id="storeLogo" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="storeName">Store Name</Label>
                    <Input type="text" id="storeName" placeholder="Enter store name" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="storePhysicalAddress">Physical Address</Label>
                    <Input
                      type="text"
                      id="storePhysicalAddress"
                      placeholder="Enter physical address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="storeBillingAddress">Billing Address</Label>
                    <Input
                      type="text"
                      id="storeBillingAddress"
                      placeholder="Enter billing address"
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="storeTax">Tax %</Label>
                    <Input type="number" id="storeTax" placeholder="Enter tax percentage" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="storeContactNumber">Contact Number</Label>
                    <Input
                      type="text"
                      id="storeContactNumber"
                      placeholder="Enter contact number"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="storeEmail">Email</Label>
                    <Input type="email" id="storeEmail" placeholder="Enter email address" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="vatNumber">VAT Number</Label>
                    <Input type="text" id="vatNumber" placeholder="Enter VAT number" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="registrationNumber">Registration Number</Label>
                    <Input
                      type="text"
                      id="registrationNumber"
                      placeholder="Enter registration number"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </TabPane>

            {/* Tab 2: Integrations */}
            <TabPane tabId="2">
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="googleSMTPUser">Google SMTP User</Label>
                    <Input type="text" id="googleSMTPUser" placeholder="Enter SMTP user" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="googleSMTPPassword">Google SMTP Password</Label>
                    <Input
                      type="password"
                      id="googleSMTPPassword"
                      placeholder="Enter SMTP password"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="payfastMerchantID">Payfast Merchant ID</Label>
                    <Input
                      type="text"
                      id="payfastMerchantID"
                      placeholder="Enter Payfast Merchant ID"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="payfastMerchantKey">Payfast Merchant Key</Label>
                    <Input
                      type="text"
                      id="payfastMerchantKey"
                      placeholder="Enter Payfast Merchant Key"
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="googleMapsAPIKey">Google Maps API Key</Label>
                    <Input
                      type="text"
                      id="googleMapsAPIKey"
                      placeholder="Enter Google Maps API Key"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="googleMapsSecret">Google Maps Secret</Label>
                    <Input
                      type="password"
                      id="googleMapsSecret"
                      placeholder="Enter Google Maps Secret"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="googleMapsFile">Google Maps Service File</Label>
                    <Input type="file" id="googleMapsFile" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="doAPIKey">DO S3 API Key</Label>
                    <Input type="text" id="doAPIKey" placeholder="Enter DO S3 API Key" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="doBucketName">DO Bucket Name</Label>
                    <Input type="text" id="doBucketName" placeholder="Enter DO Bucket Name" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="doClientKey">DO Client Key</Label>
                    <Input type="text" id="doClientKey" placeholder="Enter DO Client Key" />
                  </FormGroup>
                </Col>
              </Row>
            </TabPane>

            {/* Tab 3: Coverage Zones */}
            <TabPane tabId="3">
              <h5>Coverage Zones</h5>
              <p>Define your coverage zones here.</p>
              <Button color="primary">Add Coverage Zone</Button>
            </TabPane>

            {/* Tab 4: Other Settings */}
            <TabPane tabId="4">
              <h5>Other Settings</h5>
              <p>Additional settings can be configured here.</p>
              <Button color="primary">Save Settings</Button>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default SettingsPage;
